<template>
  <div class="slider-wrapper" v-if="rounds.length > 0">
    <carousel 
      :per-page="1" 
      :autoplay="true" 
      :loop="true" 
      :navigation-enabled="true" 
      :pagination-enabled="false" 
      :autoplay-timeout="5000"
      :navigate-to-slide-on-click="false"
      :mouse-drag="true"
      :touch-drag="true"
      :speed="500"
      :easing="ease-out"
      navigation-click-target-size="8"
      navigation-next-label="❯"
      navigation-prev-label="❮"
    >
      <slide v-for="(round, index) in rounds" :key="index">
        <div class="slide-box">
          <div class="round-info">
            <h3>{{ round.league }} - Round {{ round.round }}</h3>
            <p>{{ round.markedTips }}/{{ round.totalTips }} Tips | {{ round.points }} Total Tips</p>
          </div>
          <div class="team-logos">
            <div v-for="team in round.matches" :key="team.code" class="team">
              <img :src="team.logo" :alt="team.code" />
              <span class="material-icons customcheck" v-if="team.is_correct == 1">task_alt</span>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      rounds: []
    }
  },
  mounted() {
    this.fetchScores();
    // Prevent page scroll when touching carousel area
    this.preventPageScroll();
  },
  methods: {
    async fetchScores() {
      this.$store.dispatch('fetchScores')
        .then(response => {
          console.log(response.data);
          this.rounds = response.data;
        })
        .catch(error => {
          console.error('Error fetching scores:', error);
        });
    },
    preventPageScroll() {
      const carouselElement = this.$el.querySelector('.VueCarousel');
      if (carouselElement) {
        carouselElement.addEventListener('touchstart', (e) => {
          e.stopPropagation();
        }, { passive: true });
        
        carouselElement.addEventListener('touchmove', (e) => {
          e.stopPropagation();
        }, { passive: true });
      }
    }
  }
}
</script>

<style scoped>
.slider-wrapper {
  max-width: 420px;
  margin: 0 auto;
  padding: 20px 0;
  background: #5a87f0d8;
  color: #fff;
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
}

.slide-box {
  padding: 20px 10px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.round-info h3 {
  margin: 0;
  font-size: 20px;
  color: #ffffff;
}

.round-info p {
  margin: 5px 0 15px;
  font-size: 14px;
  color: #fff;
}

.team-logos {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}

.team {
  text-align: center;
  position: relative;
  pointer-events: none; /* Prevent interference with carousel drag */
}

.team img {
  width: 50px;
  height: 50px;
  background: #fff;
  padding: 5px;
  border-radius: 10px;
  pointer-events: none; /* Prevent interference with carousel drag */
}

.customcheck {
  color: green;
  font-size: 20px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  right: -8px;
  top: -5px;
  pointer-events: none; /* Prevent interference with carousel drag */
}

/* Custom navigation arrow styles for mobile */
.slider-wrapper >>> .VueCarousel-navigation-button {
  position: absolute;
  top: 20%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9) !important;
  border: none !important;
  border-radius: 50% !important;
  width: 44px !important;
  height: 44px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 18px !important;
  color: #333 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  z-index: 10 !important;
  cursor: pointer !important;
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: transparent !important;
}

.slider-wrapper >>> .VueCarousel-navigation-prev {
  left: 10px !important;
}

.slider-wrapper >>> .VueCarousel-navigation-next {
  right: 10px !important;
}

.slider-wrapper >>> .VueCarousel-navigation-button:hover {
  background: rgba(255, 255, 255, 1) !important;
  transform: translateY(-50%) scale(1.05) !important;
}

.slider-wrapper >>> .VueCarousel-navigation-button:active {
  transform: translateY(-50%) scale(0.95) !important;
}

/* Ensure carousel container doesn't interfere with page scroll */
.slider-wrapper >>> .VueCarousel {
  touch-action: pan-x !important;
  overflow: hidden !important;
}

.slider-wrapper >>> .VueCarousel-wrapper {
  touch-action: pan-x !important;
}

.slider-wrapper >>> .VueCarousel-inner {
  touch-action: pan-x !important;
  cursor: grab !important;
}

.slider-wrapper >>> .VueCarousel-inner:active {
  cursor: grabbing !important;
}

/* Mobile specific styles */
@media (max-width: 480px) {
  .slider-wrapper {
    max-width: 95%;
    margin: 0 auto;
  }
  
  .slider-wrapper >>> .VueCarousel-navigation-button {
    width: 40px !important;
    height: 40px !important;
    font-size: 16px !important;
  }
  
  .slider-wrapper >>> .VueCarousel-navigation-prev {
    left: 5px !important;
  }
  
  .slider-wrapper >>> .VueCarousel-navigation-next {
    right: 5px !important;
  }
}
</style>